<template>
  <!-- Header -->
  <div class="header">
    <!-- Logo -->
    <div class="header-left">
      <a class="logo" aria-label="Trang chủ" href="/">
        <img
          src="/assets/img/logominhtien.png"
          width="40"
          height="40"
          alt="MinhTien Logo"
        />
      </a>
    </div>
    <!-- /Logo -->

    <a id="toggle_btn" href="javascript:void(0);" aria-label="Ẩn/hiện sidebar">
      <span class="bar-icon">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </a>

    <!-- Header Title -->
    <div class="page-title-box">
      <h3>Content CRM</h3>
    </div>
    <!-- /Header Title -->

    <a id="mobile_btn" class="mobile_btn" href="#sidebar" aria-label="Mở menu">
      <i class="fa fa-bars" aria-hidden="true"></i>
    </a>

    <!-- Header Menu -->
    <ul class="nav user-menu">
      <!-- Notifications -->
      <li class="nav-item dropdown notification-dropdown">
        <a
          href="#"
          class="dropdown-toggle nav-link"
          :class="{
            'has-unread': unreadCount > 0,
            'is-animating-on-click': isBellAnimatingOnClick,
          }"
          @click.prevent="handleBellClick"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          aria-label="Thông báo"
        >
          <i class="fa fa-bell" aria-hidden="true"></i>
          <span
            v-if="unreadCount > 0"
            class="badge badge-pill"
            aria-live="polite"
            >{{ unreadCount }}</span
          >
        </a>

        <div class="dropdown-menu dropdown-menu-right notifications">
          <div class="topnav-dropdown-header">
            <span class="notification-title">Thông báo</span>
            <a
              v-if="unreadCount > 0"
              href="#"
              @click.prevent="markAllAsRead"
              class="clear-noti"
              aria-label="Đánh dấu tất cả đã đọc"
            >
              <i class="fas fa-check-double" aria-hidden="true"></i> Đánh dấu đã
              đọc
            </a>
          </div>

          <div class="noti-content-dropdown">
            <!-- Loading -->
            <div v-if="isLoading" class="notification-loading">
              <div
                class="spinner-border spinner-border-sm"
                role="status"
                aria-label="Đang tải"
              ></div>
              <span>Đang tải...</span>
            </div>

            <!-- Empty -->
            <ul
              v-else-if="notifications.length === 0"
              class="notification-list"
            >
              <li class="notification-empty">
                <i class="fa fa-bell"></i>
                <p>Tuyệt vời, không có gì mới!</p>
              </li>
            </ul>

            <!-- List -->
            <ul v-else class="notification-list">
              <li
                v-for="noti in notifications.slice(0, 5)"
                :key="noti.id"
                :class="[
                  'notification-item-dropdown',
                  { 'is-unread': !noti.daDoc },
                ]"
                @click="handleNotificationClick(noti)"
                role="button"
                tabindex="0"
                @keydown.enter.prevent="handleNotificationClick(noti)"
                @keydown.space.prevent="handleNotificationClick(noti)"
                :aria-label="`Mở thông báo ${formatTimeAgo(noti.thoiGianTao)}`"
              >
                <div class="unread-dot"></div>

                <div class="notification-avatar">
                  <img
                    v-if="noti.avatarNguoiGui"
                    :alt="noti.tenNguoiGui"
                    :src="noti.avatarNguoiGui"
                    loading="lazy"
                  />
                  <div
                    v-else
                    class="avatar-fallback"
                    :aria-label="noti.tenNguoiGui"
                  >
                    {{
                      (noti.tenNguoiGui || "U").trim().slice(0, 1).toUpperCase()
                    }}
                  </div>
                </div>

                <div class="notification-body">
                  <div class="notification-text" v-html="noti.noiDung"></div>
                  <div class="notification-meta">
                    <span
                      :class="[
                        'noti-tag-dropdown',
                        getTagClass(noti.loaiThongBao),
                      ]"
                    >
                      {{ getTagText(noti.loaiThongBao) }}
                    </span>
                    <span class="notification-time">{{
                      formatTimeAgo(noti.thoiGianTao)
                    }}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="topnav-dropdown-footer">
            <router-link to="/tat-ca-thong-bao"
              >Xem tất cả thông báo</router-link
            >
          </div>
        </div>
      </li>

      <!-- Nút bật/tắt realtime (web push) -->
      <li class="nav-item realtime-btn-wrapper">
        <a
          @click="toggleSubscription"
          :aria-disabled="!isPushEnabled || isPushLoading ? 'true' : 'false'"
          class="btn-sm realtime-btn"
          :class="isSubscribed ? 'btn-outline-danger' : 'btn-outline-primary'"
        >
          <i
            class="fa fa-rss"
            :class="isSubscribed ? 'blue' : 'red'"
            aria-hidden="true"
          ></i>
          <span class="realtime-text green" v-if="isPushLoading">
            Đang xử lý...</span
          >
          <span class="realtime-text blue" v-else-if="isSubscribed">
            Tắt Real-time</span
          >
          <span class="realtime-text red" v-else> Bật Real-time</span>
        </a>
      </li>

      <!-- User dropdown -->
      <li class="nav-item dropdown has-arrow main-drop">
        <a
          href="#"
          class="dropdown-toggle nav-link"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span class="user-img">
            <img :src="avatarUrl" alt="User" />
            <span class="status online"></span>
          </span>
          <span>{{ username }}</span>
        </a>
        <div class="dropdown-menu">
          <router-link to="/quan-ly-thiet-bi" class="dropdown-item"
            >Quản lý thiết bị</router-link
          >
          <router-link to="/profile" class="dropdown-item">Hồ sơ</router-link>
          <router-link to="/" class="dropdown-item">Cài đặt</router-link>
          <a class="dropdown-item" @click="logout">Đăng xuất</a>
        </div>
      </li>
    </ul>
    <!-- /Header Menu -->

    <!-- Mobile Menu -->
    <div class="dropdown mobile-user-menu">
      <a
        href="#"
        class="nav-link dropdown-toggle"
        data-toggle="dropdown"
        aria-expanded="false"
        aria-label="Mở menu người dùng"
      >
        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
      </a>
      <div class="dropdown-menu dropdown-menu-right">
        <a class="dropdown-item" href="profile.html">Hồ sơ</a>
        <a class="dropdown-item" href="settings.html">Cài đặt</a>
        <a class="dropdown-item" @click="logout">Đăng xuất</a>
      </div>
    </div>
    <!-- /Mobile Menu -->
  </div>
  <!-- /Header -->
</template>

<script>
import api from "@/api";
import { useNotificationStore } from "@/stores/notificationStore";
import { mapState, mapActions } from "pinia";
import { usePushStore } from "@/stores/pushStore";
import RBAC from "@/api/rbac";

export default {
  name: "HeaderComponent",
  data() {
    return {
      username: "Đang tải...",
      avatarUrl: "/assets/img/logominhtien.png",
      swMessageHandler: null,
      isBellAnimatingOnClick: false,
    };
  },
  computed: {
    ...mapState(useNotificationStore, [
      "notifications", // dùng trực tiếp dữ liệu trang hiện tại
      "unreadCount",
      "isLoading",
    ]),
    ...mapState(usePushStore, {
      isPushEnabled: "isPushEnabled",
      isSubscribed: "isSubscribed",
      isPushLoading: "isLoading",
    }),
  },
  mounted() {
    this.getUsernameFromStorage();
    this.fetchNotifications(1); // trang 1 (UI 1-based)
    this.checkSubscriptionStatus();
    this.attachServiceWorkerListener();
  },
  beforeUnmount() {
    this.detachServiceWorkerListener();
  },
  methods: {
    ...mapActions(useNotificationStore, [
      "fetchNotifications",
      "handleMarkAsRead",
      "handleMarkAllAsRead",
      "reset",
      "addNotification",
    ]),
    ...mapActions(usePushStore, [
      "checkSubscriptionStatus",
      "toggleSubscription",
    ]),

    formatTimeAgo(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const now = new Date();
      const diffSeconds = Math.floor((now - date) / 1000);
      if (diffSeconds < 60) return "Vài giây trước";
      const diffMinutes = Math.floor(diffSeconds / 60);
      if (diffMinutes < 60) return `${diffMinutes} phút trước`;
      const diffHours = Math.floor(diffMinutes / 60);
      if (diffHours < 24) return `${diffHours} giờ trước`;
      const diffDays = Math.floor(diffHours / 24);
      return `${diffDays} ngày trước`;
    },

    handleBellClick() {
      if (this.isBellAnimatingOnClick) return;
      this.isBellAnimatingOnClick = true;
      setTimeout(() => {
        this.isBellAnimatingOnClick = false;
      }, 1000);
    },

    getTagClass(loaiThongBao) {
      switch (loaiThongBao) {
        case "CONG_VIEC":
          return "tag-cong-viec";
        case "PHAN_CONG":
          return "tag-phan-cong";
        case "BINH_LUAN":
          return "tag-binh-luan";
        case "BINH_LUAN_MENTION":
          return "tag-nhac-binh-luan";
        case "NHAC_NHO":
          return "tag-nhac-nho";
        case "GIAY_TO":
          return "tag-giay-to";
        case "HANG_NGAY":
          return "tag-hang-ngay";
        case "THONG_KE":
          return "tag-thong-ke";
        case "QUA_HAN":
          return "tag-qua-han";
        default:
          return "tag-default";
      }
    },

    getTagText(loaiThongBao) {
      switch (loaiThongBao) {
        case "CONG_VIEC":
          return "Công việc";
        case "PHAN_CONG":
          return "Phân công";
        case "BINH_LUAN":
          return "Bình luận";
        case "BINH_LUAN_MENTION":
          return "Nhắc tên";
        case "NHAC_NHO":
          return "Nhắc nhở";
        case "GIAY_TO":
          return "Giấy tờ";
        case "HANG_NGAY":
          return "Hàng ngày";
        case "THONG_KE":
          return "Thống kê";
        case "QUA_HAN":
          return "Quá hạn";
        default:
          return "Chung";
      }
    },

    handleNotificationClick(notification) {
      if (!notification) return;

      if (!notification.daDoc) {
        try {
          this.handleMarkAsRead(notification.id);
        } catch (_) {}
      }

      const go = (link) => this.$router.push(link).catch(() => {});
      const deep =
        notification.deepLink && String(notification.deepLink).trim();

      if (deep) {
        if (/^https?:\/\//i.test(deep)) window.location.assign(deep);
        else go(deep.startsWith("/") ? deep : `/${deep}`);
        return;
      }
      if (notification.loaiDoiTuong && notification.idDoiTuong) {
        const link = `/${String(notification.loaiDoiTuong).toLowerCase()}/${
          notification.idDoiTuong
        }`;
        go(link);
        return;
      }
      go("/bang-phan-chia-cong-viec");
    },

    markAllAsRead() {
      this.handleMarkAllAsRead();
    },

    attachServiceWorkerListener() {
      if ("serviceWorker" in navigator) {
        this.swMessageHandler = (event) => {
          const data = event.data;
          if (data && data.type === "NEW_NOTIFICATION") {
            this.addNotification(data.payload);
          }
        };
        navigator.serviceWorker.addEventListener(
          "message",
          this.swMessageHandler
        );
        console.log(
          "✅ HeaderComponent: Đã bật listener lắng nghe Service Worker."
        );
      }
    },

    detachServiceWorkerListener() {
      if ("serviceWorker" in navigator && this.swMessageHandler) {
        navigator.serviceWorker.removeEventListener(
          "message",
          this.swMessageHandler
        );
        console.log("🧹 HeaderComponent: Đã dọn dẹp listener.");
      }
    },

    getUsernameFromStorage() {
      const username = localStorage.getItem("userhoten");
      const avatarUrl = localStorage.getItem("avatarUrl");

      this.username = username || "Khách";
      this.avatarUrl = avatarUrl || "/assets/img/logominhtien.png";
    },

    async logout() {
      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (refreshToken) {
          await api.post("/api/auth/logout", { refreshToken });
        }
      } catch (e) {
        console.warn(
          "Logout API failed (continuing local cleanup):",
          e?.response?.data || e?.message
        );
      } finally {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("username");
        localStorage.removeItem("userhoten");
        localStorage.removeItem("avatarUrl");
        RBAC.clear();
        if (api?.defaults?.headers?.common) {
          delete api.defaults.headers.common["Authorization"];
        }

        this.reset();
        this.detachServiceWorkerListener();

        if (this.$router) this.$router.push("/login");
      }
    },
  },
};
</script>

<style scoped>
/* (giữ nguyên toàn bộ CSS bạn đã gửi) */

/* Tag màu cho loại thông báo */
.tag-cong-viec {
  background-color: #3b82f6;
}
.tag-phan-cong {
  background-color: #14b8a6;
}
.tag-binh-luan {
  background-color: #22c55e;
}
.tag-nhac-nho {
  background-color: #f59e0b;
}
.tag-giay-to {
  background-color: #ffc86a;
}
.tag-hang-ngay {
  background-color: #ce0bf5;
}
.tag-thong-ke {
  background-color: #8b5cf6;
}
.tag-qua-han {
  background-color: #ef4444;
}
.tag-default {
  background-color: #6b7280;
}
.tag-nhac-binh-luan {
  background-color: #06c4dd;
}

/* Demo màu chữ */
.red {
  color: red;
}
.blue {
  color: blue;
}
.green {
  color: green;
}

/* Nút trong nav khớp chiều cao header */
.nav-item .btn {
  display: flex;
  align-items: center;
  height: 40px;
}
.nav-item .btn .fa {
  margin-right: 5px;
}

/* Real-time button styling */
.realtime-btn-wrapper {
  display: flex;
  align-items: center;
}
.realtime-btn {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 12px;
  white-space: nowrap;
}
.realtime-btn .fa {
  margin-right: 5px;
}

/* Trạng thái disabled cho anchor đóng vai trò button */
.realtime-btn[aria-disabled="true"] {
  pointer-events: none;
  opacity: 0.6;
}

/* Responsive cho mobile */
@media (max-width: 767px) {
  .realtime-btn-wrapper {
    margin-right: 10px;
  }
  .realtime-btn {
    padding: 0 8px;
    font-size: 12px;
  }
  .realtime-text {
    display: none;
  }
  .realtime-btn .fa {
    margin-right: 0;
    font-size: 16px;
  }
  .nav.user-menu {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .nav.user-menu > li.nav-item {
    margin: 0;
  }
}

/* Tablet */
@media (min-width: 768px) and (max-width: 991px) {
  .realtime-btn {
    padding: 0 10px;
    font-size: 13px;
  }
}

/* --- NÚT CHUÔNG THÔNG BÁO Ở HEADER --- */
.notification-dropdown .nav-link {
  position: relative;
  z-index: 1;
  font-size: 1.2rem;
}
.notification-dropdown .badge {
  position: absolute;
  top: 6px;
  right: 0px;
  font-size: 10px;
  padding: 3px 5px;
  background-color: #dc3545;
  box-shadow: 0 0 0 2px white;
}

/* --- KHUNG DROPDOWN CHUNG --- */
.notifications.dropdown-menu {
  width: 350px;
  padding: 0;
  border-radius: 8px;
  border: 1px solid #e3e3e3;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
  margin-top: 10px !important;
}

/* Header & Footer */
.topnav-dropdown-header,
.topnav-dropdown-footer {
  border-bottom: 1px solid #f0f0f0;
  background-color: #fcfcfc;
  font-size: 0.9rem;
}
.topnav-dropdown-footer {
  border-top: 1px solid #f0f0f0;
  border-bottom: none;
  text-align: center;
}
.topnav-dropdown-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.notification-title {
  font-weight: 600;
  color: #333;
}
.clear-noti {
  font-size: 0.75rem;
  color: #007bff;
  font-weight: 500;
}
.clear-noti i {
  margin-right: 4px;
}

/* --- KHUNG NỘI DUNG CUỘN --- */
.noti-content-dropdown {
  max-height: 350px;
  overflow-y: auto;
}

/* --- ITEM TRONG DROPDOWN --- */
.notification-item-dropdown {
  display: flex;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
  position: relative;
  align-items: flex-start;
  border-bottom: 1px solid #f5f5f5;
}
.notification-item-dropdown:hover {
  background-color: #f8f9fa;
}
.notification-item-dropdown:last-child {
  border-bottom: none;
}
.notification-item-dropdown.is-unread {
  background-color: #f0f8ff;
}
.notification-item-dropdown .unread-dot {
  width: 6px;
  height: 6px;
  background-color: #007bff;
  border-radius: 50%;
  position: absolute;
  left: 8px;
  top: 16px;
  opacity: 0;
}
.notification-item-dropdown.is-unread .unread-dot {
  opacity: 1;
}

.notification-item-dropdown .notification-avatar {
  margin-left: 10px;
  margin-right: 12px;
}
.notification-item-dropdown .notification-avatar img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 999px;
}
.avatar-fallback {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  background: #e9ecef;
  color: #495057;
  font-weight: 700;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
}

.notification-body {
  flex: 1;
  font-size: 0.85rem;
}
.notification-text {
  color: #4f4f4f;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.notification-item-dropdown.is-unread .notification-text {
  font-weight: 600;
  color: #111;
}

.notification-meta {
  margin-top: 5px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.notification-time {
  font-size: 0.7rem;
  color: #888;
}

.noti-tag-dropdown {
  font-size: 9px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 8px;
  color: #fff;
  text-transform: uppercase;
}

/* Loading & Empty */
.notification-loading,
.notification-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  text-align: center;
  color: #888;
}
.notification-loading span {
  margin-top: 10px;
  font-size: 0.9rem;
}
.notification-empty p {
  margin-top: 10px;
  font-size: 0.9rem;
  font-weight: 500;
}

/* Hiệu ứng rung chuông khi click */
.notification-dropdown .nav-link.is-animating-on-click .fa-bell {
  animation: bell-click-shake 1s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform-origin: center top;
}
@keyframes bell-click-shake {
  10%,
  90% {
    transform: rotate(-10deg);
  }
  20%,
  80% {
    transform: rotate(10deg);
  }
  30%,
  50%,
  70% {
    transform: rotate(-15deg);
  }
  40%,
  60% {
    transform: rotate(15deg);
  }
  100% {
    transform: rotate(0);
  }
}
.user-img img {
  width: 35px;
  height: 35px;
  margin-right: 5px;
}
</style>
